<template>
  <div id="app">
    <!-- keep-alive可以使被包含的组件状态维持不变，即便是组件切换了，其内的状态依旧维持在内存之中。在下一次显示时，也不会重现渲染。 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件，比如 page1,page2 -->
      </router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive">
      <!-- 这里是不被缓存的视图组件，比如 page3 -->
    </router-view>
    <Tab/>
  </div>
</template>
<script>
import Tab from "com/app/common/tab.vue";
export default {
  name: "App",
  components: {
    Tab: Tab
  },
  created() {
    let code = this.$route.query.code ? this.$route.query.code : "";
    this.$store.commit("SAVE_CODE", {
      code: code
    });

    // 如果是本地开发环境，就用固定的 tooken值，不然接口是不成功的，不过30天后也会过期
    if (process.env.NODE_ENV === "development") {
      this.$store.commit("SAVE_TOKEN", {
        token: "a3d4108a062c076d75c04afaa9603ddd"
      });
      // this.$store.dispatch("GET_USER");
    } else {
      //如果是生产环境就用要每次都会获取新的 token
      // this.$store.dispatch("GET_TOKEN");

      // // 如果是要在手机上环境测试，用这个
      // this.$store.commit('SAVE_TOKEN', {
      //   token: 'a3d4108a062c076d75c04afaa9603ddd'
      // })
      // this.$store.dispatch('GET_USER')
    }
  },
};
</script>
<style lang="less">
// 引入公共的样式
@import url("./less/index.less");
.mint-indicator-wrapper {
  padding: 10px 25px !important;
}

.mint-indicator-wrapper {
  z-index: 999999;
}

.l-footer__page {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue